//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2019
//----------------------------------------------------------------------------------------------------------------

export function IsElectronContext() {
  if (typeof window === "undefined") {
    return false;
  }

  return !!window.PA_IsElectronContext || !!window.ElectronWebsocketMode;
}

export function IsSketchUpContext() {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    typeof window.sketchup?.SKP_ExecuteSync === "function" &&
    typeof window.sketchup?.SKP_ExecuteAsync === "function"
  );
}

export function IsDarkTheme() {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.window.localStorage.getItem("theme") === "dark" ||
    window.window.localStorage.getItem("theme") === "dark_light"
  );
}

export function ForceOneWindowRouter() {
  if (typeof window === "undefined") {
    return false;
  }

  return window.window.localStorage.getItem("router") === "singleview";
}

export function IsRunningAsBrowser() {
  if (typeof window === "undefined") {
    return false;
  }

  return !(
    IsElectronContext() ||
    window.IsVectorworksContext ||
    window.IsIOS ||
    window.Android ||
    window.ElectronWebsocketMode ||
    IsSketchUpContext()
  );
}

export const kAluvisionRouteTab = "aluvision";
